import { FC } from 'react';
import {
  VictimContainer,
  Header,
  Content,
  VictimTitle,
  InputField,
} from 'containers/ExpertExpertise/Victim/style';
import Document from 'components/Document';
import VisibilityIcon from '@material-ui/icons/Visibility';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { openDocument } from 'containers/UploadDocuments/utils';
import VictimIconBlack from 'components/SahamIcons/VictimIconBlack';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/ExpertExpertise/Victim/messages';
import { VictimType } from 'containers/ExpertExpertise/Victim/typings';
import { useSelector } from 'react-redux';
import { get, isEmpty, isNil } from 'lodash';
import { getCity } from 'containers/RecapManagerPage/utils';
import { getLiveDocumentViewUrlIntervenant } from 'services/api-path';

export interface VictimProps {
  intl: IntlShape;
  victim: VictimType;
  courtFileNumber: string;
  expertiseDate: string;
  missionReference: string;
  requestGetDocByDocumentumId: Function;
}

const Victim: FC<VictimProps> = props => {
  const { victim, courtFileNumber, expertiseDate, missionReference } = props;
  const cities = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'villes'], []),
  );
  return (
    <VictimContainer>
      <Header>
        <VictimIconBlack />
        <VictimTitle>{translate(messages.victim, props)}</VictimTitle>
      </Header>
      <Content>
        <InputField
          label={translate(messages.reference, props)}
          defaultValue={missionReference}
          InputProps={{
            readOnly: true,
          }}
        />
        {courtFileNumber && (
          <InputField
            label={translate(messages.courtFileNumber, props)}
            defaultValue={courtFileNumber}
            InputProps={{
              readOnly: true,
            }}
          />
        )}
        <InputField
          label={translate(messages.lastName, props)}
          defaultValue={victim?.lastName}
          InputProps={{
            readOnly: true,
          }}
        />
        <InputField
          label={translate(messages.firstName, props)}
          defaultValue={victim?.firstName}
          InputProps={{
            readOnly: true,
          }}
        />
        <InputField
          label={translate(messages.expertiseDate, props)}
          defaultValue={expertiseDate === 'Invalid date' ? '-' : expertiseDate}
          InputProps={{
            readOnly: true,
          }}
        />
        <InputField
          label={translate(messages.city, props)}
          defaultValue={getCity(cities, victim?.city)?.ItemDescription}
          InputProps={{
            readOnly: true,
          }}
        />
      </Content>
      <Content>
        {featureService.hasFeature(FEATURES.TRANSACTION) &&
          !isEmpty(get(victim, 'transactions', [])) &&
          get(victim, 'transactions', []).map(
            (el: any) =>
              !isEmpty(get(el, 'documents', [])) &&
              get(el, 'documents', []).map((item: any) => (
                <Document
                  name={get(item, 'name', '')}
                  type={get(item, 'type', '')}
                  icon={
                    <VisibilityIcon
                      className="consult"
                      onClick={
                        !isNil(get(item, 'documentumId', null))
                          ? () =>
                              props.requestGetDocByDocumentumId(
                                getLiveDocumentViewUrlIntervenant(
                                  get(item, 'documentumId', null),
                                ),
                              )
                          : openDocument(get(item, 'url', ''))
                      }
                    />
                  }
                />
              )),
          )}
      </Content>
    </VictimContainer>
  );
};

export default injectIntl(Victim);
